import { render, staticRenderFns } from "./FilePreview.vue?vue&type=template&id=b8cba164"
import script from "./FilePreview.vue?vue&type=script&lang=js"
export * from "./FilePreview.vue?vue&type=script&lang=js"
import style0 from "./FilePreview.vue?vue&type=style&index=0&id=b8cba164&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8cba164')) {
      api.createRecord('b8cba164', component.options)
    } else {
      api.reload('b8cba164', component.options)
    }
    module.hot.accept("./FilePreview.vue?vue&type=template&id=b8cba164", function () {
      api.rerender('b8cba164', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/utils/FilePreview.vue"
export default component.exports